<template>
    <li
        class="mb-4"
        :class="{ 'pl-16 text-right' : message.type !== 'incoming', 'pr-16 text-left' : message.type === 'incoming' }"
    >
        <div class="text-sm text-gray-600">
            <strong>{{ message.true_send_time ? "Sent at " + message.true_send_time : 'Pending send...' }}</strong>
            <span v-if="message.group_name">to list <strong>{{message.group_name}}</strong></span>
        </div>
        <div v-if="message.media && Array.isArray(message.media)">
            <div v-for="url in message.media"
                    class="flex flex-row"
                    :class="{ 'justify-start' : message.type === 'incoming', 'justify-end' : message.type !== 'incoming' }">
                <img :src="url" class="max-w-xs rounded-lg my-2" />
            </div>
        </div>
        <div v-if="message.media && !Array.isArray(message.media)">
        <div class="flex flex-row"
                :class="{ 'justify-start' : message.type === 'incoming', 'justify-end' : message.type !== 'incoming' }">
            <img :src="message.media" class="max-w-xs rounded-lg my-2" />
        </div>
        </div>
        <div
            v-if="message.parsed_message"
            class="inline-block py-2 px-4 rounded-lg font-bold"
            :class="[messageBGColor]"
        >
            {{ message.parsed_message }}
        </div>
    </li>
</template>
<script>
    export default {
        props: {
            message: {
                type: Object,
                default: () => {
                    return {}
                }
            },
        },
        methods: {
        },
        computed: {
            messageBGColor() {
                if (!this.message) return "";

                if (this.message.type == "incoming") {
                    return "bg-gray-300 text-black";
                }
                if (this.message.group_name) {
                    return "bg-purple-600 text-white";
                }

                return "bg-blue-600 text-white";
            },
        },
    }
</script>

<style scoped>
</style>
